import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, combineLatest } from 'rxjs';
import { QuoteDetail, WorkOrder, WorkOrderCase } from '@quorum/models/xs-resource';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'sha-service-history',
  templateUrl: './service-history.component.html',
  styleUrls: ['./service-history.component.scss'],
})
export class ServiceHistoryComponent implements OnInit, OnDestroy {
  @Input() serviceHistory$: Observable<WorkOrder[]>;
  @Input() openQuoteLines$: Observable<QuoteDetail[]>;
  @Input() sortBy: string;
  @Input() sortDirection: string;
  @Output() collapsedChange = new EventEmitter<boolean>();
  unlinkedQuoteLinesArr$: Observable<QuoteDetail[]>;
  sort: string;
  serviceHistoryUi: { collapsed: boolean } = { collapsed: false };
  filterForm = this.fb.group({
    serviceHistoryFilter: [''],
  });
  serviceHistorySub$: Subscription;
  filteredServiceHistory$: BehaviorSubject<WorkOrder[]> = new BehaviorSubject<WorkOrder[]>([]);
  caseNoteMaxLength = 140;

  constructor(private fb: FormBuilder) {}

  ngOnDestroy() {
    this.serviceHistorySub$.unsubscribe();
  }

  ngOnInit() {
    this.sort = (this.sortDirection == 'ascending' ? '+' : '-') + (this.sortBy ? this.sortBy : 'id');
    this.unlinkedQuoteLinesArr$ = this.serviceHistory$.pipe(
      map((serviceHistoryData) => {
        const workOrderIdsArr: number[] = [];
        serviceHistoryData.map((workOrder) => {
          workOrderIdsArr.push(workOrder.id);
        });
        return workOrderIdsArr;
      }),

      switchMap((workOrderIds: number[]) => {
        const ids = [...workOrderIds];
        return this.openQuoteLines$.pipe(
          map((quoteItems: QuoteDetail[]) => {
            const unlinkedQuotesArr = quoteItems.filter((quote: QuoteDetail) => !ids.includes(quote.workHeaderId));
            return unlinkedQuotesArr;
          })
        );
      })
    );

    this.serviceHistorySub$ = combineLatest([
      this.filterForm.get('serviceHistoryFilter').valueChanges.pipe(debounceTime(250), distinctUntilChanged()),
      this.serviceHistory$.pipe(
        map((serviceHistory) => {
          this.filteredServiceHistory$.next(serviceHistory);
          return serviceHistory;
        })
      ),
    ])
      .pipe(
        map(([formValue, serviceHistory]) => {
          return { formValue, serviceHistory };
        })
      )
      .subscribe((data) => {
        if (data.formValue && data.formValue.length > 0) {
          this.filteredServiceHistory$.next(
            data.serviceHistory.filter((wo: WorkOrder) =>
              data.formValue && data.formValue.length > 0
                ? (wo.embedded && wo.embedded.cases && wo.embedded.cases.length > 0) ||
                  ('RO ' + wo.id.toString()).toLowerCase().includes(data.formValue.toLowerCase())
                  ? wo.embedded.cases.filter(
                      (woCase: WorkOrderCase) =>
                        woCase.labourOp?.toLowerCase().includes(data.formValue.toLowerCase()) ||
                        woCase.note?.toLowerCase().includes(data.formValue.toLowerCase())
                    ).length > 0 || ('RO ' + wo.id.toString()).toLowerCase().includes(data.formValue.toLowerCase())
                    ? true
                    : false
                  : false
                : false
            )
          );
        } else {
          this.filteredServiceHistory$.next(data.serviceHistory);
        }
      });
  }

  filteredOpenQuoteLinesByWorkOrder(workOrderId: number) {
    return this.openQuoteLines$.pipe(
      map((quoteItems) => {
        const filteredQuoteLinesArr = quoteItems.filter((quote) => quote.workHeaderId === workOrderId);
        return filteredQuoteLinesArr;
      })
    );
  }

  toggleServiceHistoryCollapse(serviceHistoryUi: { collapsed: boolean }) {
    serviceHistoryUi.collapsed = !serviceHistoryUi.collapsed;
    this.collapsedChange.emit(serviceHistoryUi.collapsed);
  }
}
